import { useNavigate, useSearchParams } from 'react-router-dom';
import { RISK_REGISTER_URL } from '@/constants';

export const useRedirectToRegister = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const freight = searchParams.get('frete');

  const keyHasBeenAppended = (uri: string, key: string) => new RegExp(`${key}=.*`).test(uri);

  const updateURL = (uri: string, key: string, value: string) => {
    if (keyHasBeenAppended(uri, key)) return uri;
    const separator = uri.includes('?') ? '&' : '?';
    return `${uri}${separator}${key}=${value}`;
  };

  const getRedirectToRegisterURL = (personId?: string) => {
    let url = RISK_REGISTER_URL;

    if (freight) url = updateURL(url, 'frete', freight);
    if (personId) url = updateURL(url, 'motorista', personId);

    return url;
  };

  return (personId?: string) => {
    const redirectURL = getRedirectToRegisterURL(personId);
    navigate(redirectURL, { replace: true });
  };
};
